import React from 'react';
import { AbsoluteFill, OffthreadVideo } from 'remotion';
import type { ProjectModel } from '@video-studio/shared';

/**
 * Achtergrondlaag.
 *
 * In fase 2 en verder bouwt de worker één basistrack (alle videoclips op
 * project-fps, inclusief overgangen en de volledige audiomix). Die track komt
 * hier als achtergrond binnen, zodat de compositie alleen nog de overlaylagen
 * (tekst, afbeeldingen, logo's) hoeft te renderen. Dat is sneller en het
 * voorkomt dat de browser honderden videobestanden tegelijk moet decoderen.
 *
 * Zonder basistrack (fase 1, of een export zonder videoclips) is dit een lege
 * laag; de losse videolagen doen dan het werk.
 */
export interface ProjectAchtergrondProps {
  project: ProjectModel;
  basistrackUrl?: string;
}

export const ProjectAchtergrond: React.FC<ProjectAchtergrondProps> = ({ project, basistrackUrl }) => {
  if (!basistrackUrl) {
    return <AbsoluteFill style={{ backgroundColor: project.achtergrond.kleur }} />;
  }
  return (
    <AbsoluteFill style={{ backgroundColor: project.achtergrond.kleur }}>
      <OffthreadVideo
        src={basistrackUrl}
        muted={false}
        pauseWhenBuffering
        style={{ width: '100%', height: '100%', objectFit: 'fill' }}
      />
    </AbsoluteFill>
  );
};
